<template>
  <div class="dateInp" :class="{ 'opacity': isDateTypeAll }">
    <date-picker :startDate="startDate" :endDate="endDate" :disabled="disabled" :disabledDates="['afterToday']" @child="updateDates"></date-picker>

<!--    <vue-ctk-date-time-picker-->
<!--      id="ticket_list_time_start"-->
<!--      v-model="startDate"-->
<!--      color="#287696"-->
<!--      format="YYYY-MM-DD"-->
<!--      formatted="YYYY-MM-DD"-->
<!--      label="시작일"-->
<!--      auto-close-->
<!--      disable-time-->
<!--      :disabled="disabled"-->
<!--    ></vue-ctk-date-time-picker>-->
<!--    <span class="mt-2 mx-2">~</span>-->
<!--    <vue-ctk-date-time-picker-->
<!--      id="ticket_list_time_end"-->
<!--      v-model="endDate"-->
<!--      color="#287696"-->
<!--      format="YYYY-MM-DD"-->
<!--      formatted="YYYY-MM-DD"-->
<!--      label="종료일"-->
<!--      auto-close-->
<!--      disable-time-->
<!--      :disabled="disabled"-->
<!--    ></vue-ctk-date-time-picker>-->
  </div>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  name: 'ticket_list_time_picker',
  props: {
    updateDate: Function,
    disabled: Boolean,
    initDate: Function,
    pageType: String,
    startDate: String,
    endDate: String,
    dateBtn: String
  },
  data: () => ({
    day: [],
    isStartFirst: true,
    isEndFirst: true
  }),
  computed: {
    isDateTypeAll () {
      return this.dateBtn === '-1'
    }
  },
  watch: {
    startDate (newVal, oldVal) {
      if (!TicketListUtil.checkEndTimeIsAfter(newVal, this.endDate)) {
        this.$alertMsg('開始日は終了日より後には設定できません。')
        this.startDate = oldVal
      } else {
        if (!this.isStartFirst) {
          this.$parent.updateStartDate(newVal)
        }
        this.isStartFirst = false
      }
    },
    endDate (newVal, oldVal) {
      if (!TicketListUtil.checkEndTimeIsAfter(this.startDate, newVal)) {
        this.$alertMsg('開始日は終了日より後には設定できません。')
        this.endDate = oldVal
      }

      if (!this.isEndFirst) {
        this.$parent.updateEndDate(newVal)
      }
      this.isEndFirst = false
    }
  },
  mounted () {
    this.$parent.startDate = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.START_DATE, localStorage.getItem('TICKET_LIST_OPTION'))
    this.$parent.endDate = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.END_DATE, localStorage.getItem('TICKET_LIST_OPTION'))
  },
  methods: {
    updateDates (date) {
      this.$parent.startDate = date.start
      this.$parent.endDate = date.end
      this.updateDate(date.start, date.end)
    }
  }
}
</script>

<style>
  @media screen and (max-width: 415px) {
    .datetimepicker .datepicker .datetimepicker-container[data-v-2e8d133d] {
      padding-top: 70px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_list_time_picker.vue